module.exports = __webpack_public_path__ + "assets/images/rate-my-agent-icoc6d46748.png";